import './register.scss';
import InfoBlue from '../../../assets/images/icons/info-blue.png';
import Docs from '../../../assets/images/icons/docs.png';
import Profile from '../../../assets/images/icons/profile-full.png';
import Email from '../../../assets/images/icons/mail.png';
import Phone from '../../../assets/images/icons/phone.png';
import Location from '../../../assets/images/icons/location.png';
import Street from '../../../assets/images/icons/street.png';
import Neighbour from '../../../assets/images/icons/neighbour.png';
import Number from '../../../assets/images/icons/number.png';
import Comp from '../../../assets/images/icons/comp.png';
import City from '../../../assets/images/icons/city.png';
import State from '../../../assets/images/icons/state.png';

import Loader from '../../../assets/images/loaders/loader.gif';

import React, { useState } from "react";
import { RegisterProps } from "../../../types/helpers";
import { documentInputFormatter, phoneFormatter } from '../../../utils';
import { ActionButton } from '../../utils/action-button/actionButton';
import { useAppDispatch, useAppSelector } from '../../../features';
import { getRegisterStatus, setRegisterDetails } from '../../../store/RegisterSlice';
import { setNotification } from '../../../store/NotificationSlice';

export const RegisterHome : React.FC<RegisterProps> = ({increaseStep, decreaseStep}) => {

    const dispatch = useAppDispatch();

    const [formattedNumber, setFormattedNumber] = useState<string | null>(null);
    const [formattedNumberMobile, setFormattedNumberMobile] = useState<string | null>(null);
    const [loadingClient, setLoadingClient] = useState(true);
    const [loadingRegister, setLoadingRegister] = useState(false);
    const [registerStep, setRegisterStep] = useState(0);

    const registerFormStatus = useAppSelector(getRegisterStatus);

    const handleChange = (e:any) => {
        const value = e.target.value;
        if (value.length > 14) {
            e.target.value = value.slice(0, 14);
        } else {
            const formattedValue = documentInputFormatter(value);
            setFormattedNumber(formattedValue);
        }
    }

    const handleChangeMobile = (e:any) => {
        const value = e.target.value;
        if (value.length > 13) {
            e.target.value = value.slice(0, 13);
        } else {
            const formattedValue = phoneFormatter(value);
            setFormattedNumberMobile(formattedValue);
            handleOnChangeFieldForm('mobile', formattedValue);
        }     
    }

    const handleOnChangeFieldForm = (field:string,value:any) => {
        const val = value.target ? value.target.value : value;
        dispatch(setRegisterDetails({ field, value: val }));
    }

    const nextRegisterStep = () => {
        if(registerStep === 0) {
            dispatch(setRegisterDetails({field: 'doc', value: formattedNumber}));
            setRegisterStep(1);
            const timer = setTimeout( () => {
                clearTimeout(timer);
                setLoadingClient(false);
            }, 1000);
        }
    }

    const sendRegisterForm = () => {
        setLoadingRegister(true);
        const payload = {status: true,msg: 'uhsduidhfsdui',class:'error',position:'top'}
        dispatch(setNotification(payload));
        const timer = setTimeout( () => {
            setLoadingRegister(false);
            clearTimeout(timer);
        }, 6000)
    }

    const isValidForm = () : boolean => {
        return !(!loadingRegister && registerFormStatus)
    }

    return (
        <div className="register-wrapper">
            <div className="card blue">
                <img src={InfoBlue} alt=""/>
                <div className="info">
                    <p>Que bom que você se interessou em se registrar em nossa plataforma!</p>
                    <h2>Vantagens de se registrar:</h2>
                    <ul>
                        <li>Maior limite mensal para compra de moedas</li>
                        <li>Menos Burocracia</li>
                        <li>Maior Velocidade</li>
                        <li>Menos Taxa</li>
                    </ul>
                </div>
            </div>

            <div>[Plano Selecionado]</div>
            
            <div className="steps-wrapper">
                <div className="steps step-one">
                    <h1>
                        2. Precisamos do seu documento: 
                    </h1>
                    <div className="input-wrapper input-wrapper-doc">
                        <img src={Docs} alt="" className='input-img'/>
                        <input type="number" onChange={handleChange} placeholder="Digite seu CPF ou CNPJ"/>
                        <p className={!formattedNumber ? 'unset' : ''} >{formattedNumber || 'Digite o CPF ou CNPJ'}</p>
                    </div>
                    <ActionButton 
                        label='Próximo' 
                        onClick={nextRegisterStep}
                        stylish='btn-purple'
                        disabled={
                            (registerStep === 1 ||   !(formattedNumber && (formattedNumber.length === 14 || formattedNumber.length === 18)))
                        }
                        />

                </div>

                <div className="steps step-two">
                    { registerStep > 0 && loadingClient && (<img alt="" src={Loader} className='loader'/>)}
                    { registerStep > 0 && !loadingClient && (
                        <>
                            <h1>
                                2. Dados do cliente:
                            </h1>
                            <div className="input-wrapper">
                                <img src={Profile} alt="" className='input-img'/>
                                <input type="text" placeholder='Nome Completo' name="nome" 
                                    onChange={(e) => handleOnChangeFieldForm('name', e)}/>
                            </div>
                            <div className="input-wrapper">
                                <img src={Email} alt="" className='input-img'/>
                                <input type="email" placeholder='E-mail' name="email"
                                onChange={(e) => handleOnChangeFieldForm('email', e)}/>
                            </div>
                            <div className="input-wrapper input-wrapper-doc">
                                <img src={Phone} alt="" className='input-img'/>
                                <input type="number" onChange={handleChangeMobile} name="phone"/>
                                <p className={!formattedNumberMobile ? 'unset' : ''} >{formattedNumberMobile || 'Telefone'}</p>
                            </div>
                            <h1>
                                3. Endereço do cliente:
                            </h1>
                            <div className="input-wrapper">
                                <img src={Location} alt="" className='input-img'/>
                                <input type="text" placeholder='código CEP' name="zipcode"
                                onChange={(e) => handleOnChangeFieldForm('zipcode', e)}/>
                            </div>
                            <div className="input-wrapper">
                                <img src={Street} alt="" className='input-img'/>
                                <input type="text" name="street" placeholder='nome da rua...'
                                onChange={(e) => handleOnChangeFieldForm('street', e)}/>
                            </div>
                            <div className="columns">
                                <div className="input-wrapper">
                                    <img src={Number} alt="" className='input-img'/>
                                    <input type="number" name="number" placeholder='899'
                                    onChange={(e) => handleOnChangeFieldForm('number', e)}/>
                                </div>
                                <div className="input-wrapper">
                                    <img src={Comp} alt="" className='input-img'/>
                                    <input type="text" name="complement" placeholder='complemento'
                                    onChange={(e) => handleOnChangeFieldForm('comp', e)}/>
                                </div>
                            </div>
                            <div className="input-wrapper">
                                <img src={Neighbour} alt="" className='input-img'/>
                                <input type="text" name="neightbour" placeholder='bairro de residencia'
                                onChange={(e) => handleOnChangeFieldForm('neighbour', e)}/>
                            </div>
                            <div className="columns">
                                <div className="input-wrapper">
                                    <img src={City} alt="" className='input-img'/>
                                    <input type="text" name="city" placeholder='nome da cidade'
                                    onChange={(e) => handleOnChangeFieldForm('city', e)}/>
                                </div>
                                <div className="input-wrapper">
                                    <img src={State} alt="" className='input-img'/>
                                    <input type="text" name="state" placeholder='Estado'
                                    onChange={(e) => handleOnChangeFieldForm('state', e)}/>
                                </div>
                            </div>
                                
                            <ActionButton 
                                label='Registrar-se' 
                                onClick={sendRegisterForm} 
                                stylish='btn-purple'
                                disabled={isValidForm()}
                                />                                
                        </>
                    )}
                </div>            
            </div>
        </div>
    )
}